import styled from 'styled-components'

export const StyledLogo = styled.img`
  max-width: 260px;
`
